import React from 'react';
export default function DeployedCode(_a) {
    var className = _a.className;
    return (React.createElement("svg", { className: className, width: "1em", height: "1em", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 -960 960 960" },
        React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", d: "M450-154v-309L180-619v309zm60 0 270-156v-310L510-463zm-30-360 266-155-266-154-267 154zM120-275v-410l360-207 360 207v410L480-68zm360-205" })));
}
